export const searchPlaceQueryKeys = {
  all: ['search', 'places'] as const,
  lists: () => [...searchPlaceQueryKeys.all, 'list'] as const,
  list: (placeIds: Array<string>, requireGeom: boolean) =>
    [...searchPlaceQueryKeys.lists(), [...placeIds].sort(), requireGeom] as const,
};
